var _paq = window._paq = window._paq || [];
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function() {
    var u = document.getElementById('matomo_script').getAttribute('data-url') + "/"
    var i = document.getElementById('matomo_script').getAttribute('data-id')
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', i]);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
})();
